let results = [];
function delay(timer, promise) {
  return new Promise(function (resolve) {
    if (timer <= 0) {
      resolve(promise);
    } else {
      setTimeout(resolve.bind(null, promise), timer);
    }
  });
}

export default function (array, delayT) {
  return array.reduce((p, item, index) => {
    let localDelay = delayT;
    if (index === 0) {
      localDelay = 0;
    }
    return delay(localDelay, item).then((res) => {
      results.push(res);
    });
  }, Promise.resolve(results));
}



// WEBPACK FOOTER //
// ./src/utils/iteratePromise.js